import { AppError } from '@libs/shared/models';
import { StatusCodes } from 'http-status-codes';

/**
 * Error used when the user has no customers with the required permission.
 * The app handles this case differently from a normal login error.
 */
export class NoPermittedCustomersError extends AppError {
  public static readonly ERROR_CUSTOMERS_NOT_PERMITTED: string = 'NoPermittedCustomersError';

  public constructor() {
    super(
      StatusCodes.FORBIDDEN,
      'The user does not have any valide customers',
      NoPermittedCustomersError.ERROR_CUSTOMERS_NOT_PERMITTED,
    );

    this.name = NoPermittedCustomersError.ERROR_CUSTOMERS_NOT_PERMITTED;
  }
}
